import { render, staticRenderFns } from "./printIdentity.vue?vue&type=template&id=fa884d7c&scoped=true"
import script from "./printIdentity.vue?vue&type=script&lang=js"
export * from "./printIdentity.vue?vue&type=script&lang=js"
import style0 from "./printIdentity.vue?vue&type=style&index=0&id=fa884d7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa884d7c",
  null
  
)

export default component.exports